import { FC } from 'react';

import { CloseCrossBtn } from '../icons/close-cross-btn';

export interface GroupConnectionRequestNotificationProps {
  displayName: string;
  onAccept: () => void;
  onDismiss: () => void;
}

/**
 * Карточка уведомления для психолога: один клиент ожидает разрешение на подключение к конференции.
 * Отображается справа снизу, может наслаиваться с другими такими же карточками.
 */
export const GroupConnectionRequestNotification: FC<GroupConnectionRequestNotificationProps> = ({
  displayName,
  onAccept,
  onDismiss,
}) => (
  <div className="flex flex-col w-[400px] max-w-[calc(100vw - 32px)] gap-2 rounded-[12px] bg-[#2C3038] text-white p-4 shadow-lg">
    <div className="flex items-start justify-between">
      <p className="text-[16px] font-medium leading-tight">Клиент ожидает разрешения</p>
      <button
        type="button"
        onClick={onDismiss}
        className="flex-shrink-0 p-0.5 rounded cursor-pointer hover:bg-white/10 transition-colors"
        aria-label="Закрыть"
      >
        <CloseCrossBtn width={20} height={20} className="[&_path]:stroke-white" />
      </button>
    </div>
    <p className="text-sm text-[#fff] font-light">Клиент {displayName} ожидает подключение к конференции.</p>
    <div className="flex justify-end gap-2 flex-wrap">
      <button
        type="button"
        onClick={onDismiss}
        className="px-4 py-2 rounded-xl cursor-pointer text-white/90 font-light text-base border border-white/25 hover:bg-white/10 transition-colors"
      >
        Скрыть
      </button>
      <button
        type="button"
        onClick={onAccept}
        className="px-4 py-2 rounded-xl cursor-pointer text-[#FFFFFF] font-light text-base bg-white/15 hover:bg-white/25 transition-colors"
      >
        Принять запрос
      </button>
    </div>
  </div>
);
